var exports = {
  "n": "dialogHeaderContainer__Ox4JiS",
  "A": "signatureLinkContent__kDaYFs",
};

module.exports = exports;
